import { createFileRoute } from '@tanstack/react-router';
import { AnonymousListRouteView } from '@/pages/workspaces/anonymous/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The anonymous in-app messages list. No `appBundle`: this URL has no `journeys` segment for the
 * resolver to rebuild from.
 */
function AnonymousRoute() {
  return (
    <LastWorkspaceResolver>
      <AnonymousListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/anonymous')({
  component: AnonymousRoute,
});
